
import $ from 'jquery';
import ScrollMagic from 'scrollmagic';

let options = {
    header: {
        classes: {
            sticky: 'is-sticky',
            alternate: 'is-alternate'
        },
        threshold: 250, // scroll distance in px
        throttle: 16.66 // calculate with 1000 / desired fps
    }
}

export default {
    init() {
        console.log('component/animations.js:', $('body').attr('class'));

        animate_header();
        animate_on_view();
    }
}

function animate_header() {
    let header = $('.main-header');
    let sticky = false;
    let alternate = window.scrollY > options.header.threshold;

    $(window).on('scroll', throttle(() => {
        // add class after threshold is reached
        if (!sticky && window.scrollY > options.header.threshold) {
            header.addClass(options.header.classes.sticky);
            sticky = true;
        }

        if (sticky && window.scrollY < options.header.threshold) {
            header.removeClass(options.header.classes.sticky);
            sticky = false;
        }

        // remove class after window height is reached
        if (!alternate && window.scrollY < window.innerHeight - 45) {
            header.addClass(options.header.classes.alternate);
            alternate = true;
        }

        if (alternate && window.scrollY > window.innerHeight - 45) {
            header.removeClass(options.header.classes.alternate);
            alternate = false;
        }
    }, options.header.throttle));

    $(window).trigger('scroll');
}


function animate_on_view() {
    let elements = $('[class*="aov"]');

    elements.each((index, element) => {
        bind_on_view(element);
    });
}

function bind_on_view(element) {
    let entered = false;

    new ScrollMagic.Scene({
        triggerElement: element,
        triggerHook: 0.75,
        reverse: true
    })
        .on('enter', function () {
            element.classList.add('on-view');
            entered = true;
        })
        .on('leave', function () {
            if (entered) {
                element.classList.remove('on-view');
                entered = false;
            }
        })
        .addTo(new ScrollMagic.Controller())
    ;
}

function throttle(func, delay) {
    let timeout = null;

    return (...args) => {
        if (!timeout) {
            timeout = setTimeout(() => {
                func.call(this, args);
                timeout = null;
            }, delay);
        }
    };
}